/**
 *
 */
export function useSmoothScroll(): {
  scrollToElement: (container: HTMLElement, targetLeft: number, initialSelected?: boolean) => void;
} {
  function scrollToElement(
    container: HTMLElement,
    targetLeft: number,
    initialSelected?: boolean,
  ): void {
    /*                                  */
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion || initialSelected) {
      /*                                                                      */
      container.style.scrollBehavior = "auto";
      container.scrollLeft = targetLeft;
      return;
    }

    const startLeft = container.scrollLeft;
    const distance = targetLeft - startLeft;

    /*                                               */
    if (Math.abs(distance) < 1) {
      container.style.scrollBehavior = "auto";
      container.scrollLeft = targetLeft;
      return;
    }

    container.style.scrollBehavior = "smooth";
    container.scrollLeft = targetLeft;
  }

  return {
    scrollToElement,
  };
}
